import { render, staticRenderFns } from "./xuanti.vue?vue&type=template&id=3ca3a404&scoped=true&"
import script from "./xuanti.vue?vue&type=script&lang=js&"
export * from "./xuanti.vue?vue&type=script&lang=js&"
import style0 from "./xuanti.vue?vue&type=style&index=0&id=3ca3a404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca3a404",
  null
  
)

export default component.exports